<template>
    <component :is="template">
        <v-responsive width="100%">
            <v-card elevation="0">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">도서선물내역 조회</h2>
                </div>

                <div>
                    <v-data-table :items="purchases" :headers="purchasesHeaders" disable-pagination disable-sort hide-default-footer>
                        <template slot="item.purchaseNo" slot-scope="{item}">{{ item.purchaseNo || item?.order?.orderNo }}</template>
                        <template slot="item.product" slot-scope="{item}">
                            <div class="d-flex align-center text-left">
                                <div>
                                    <v-img :src="item?.product?.thumb" width="96" height="96" contain></v-img>
                                </div>
                                <div style="width:calc(100% - 96px);">
                                    <div class="mx-2 text-truncate"><b class="text-truncate" v-html="item.product.name"></b></div>
                                    <div class="mx-2 text-truncate">{{ item.product.salePrice.format() }}원</div>
                                </div>
                            </div>
                        </template>
                        <span slot="item.status" slot-scope="{item}">{{ item.status || item.purchase?.status }}</span>
                        <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                        <span slot="item.resend" slot-scope="{item}">
                            <v-icon v-if="item.issue?.pins?.length" small @click="resend(item)">mdi-message</v-icon>
                        </span>
                        <div slot="item.shippingInfo" slot-scope="{item}">
                            <div>{{ item.shippingInfo.method }}</div>
                            <div>{{ item.shippingInfo.invoiceNumber }}</div>
                            <div>{{ couriers.find(courier => courier.value == item.shippingInfo.courier)?.text }}</div>
                        </div>
                        <div slot="item.actions" slot-scope="{item}">
                        </div>
                    </v-data-table>
                </div>
            </v-card>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)"/>
            </div>

            <claim-dialog ref="claimDialog" @claim="search(false)" />
        </v-responsive>
    </component>
</template>
<script>
import api from "@/api";
import ClaimDialog from "@/components/client/mypage/claim-dialog.vue";
import couriers from "@/assets/data/couriers.json";
export default {
    components: {
        ClaimDialog
    },
    data(){
        return {
            couriers,

            filter: {
                type: "gift"
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            purchases: [],
            purchasesHeaders: [
                { text: "구매주문번호", value: "purchaseNo", align: "center", width: "17%" },
                { text: "구매상품", value: "product", align: "center", width: "45%" },
                { text: "구매수량", value: "quantity", align: "center", width: "12%" },
                { text: "선물상태", value: "giftStatus", align: "center", width: "12%" },
                { text: "주문일자", value: "createdAt", align: "center", width: "14%" },
                // { text: "-", value: "actions", align: "center" },
            ]
        }
    },
    mounted(){
        if(this.logoff) this.$router.push(`/login`);
        this.init();
    },
    methods: {
        async init(){
            await this.search(false);
        },
        async resend(purchase){
            await api.v1.me.shop.purchases.resend(purchase);
            alert("재발송되었습니다");
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, purchases } = await api.v1.me.shop.purchases.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter
            });

            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.purchases = purchases;
        },
        async claim(purchase, claimType){
            this.$refs.claimDialog.claimType = claimType;
            this.$refs.claimDialog.purchase = purchase;
            this.$refs.claimDialog.open();
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`) },

        logoff(){
            return !this.$store.state.accessToken;
        }
    }
}
</script>

<style scoped>
</style>